import BrickRecommendations from './BrickRecommendations';
import BrickRecommendationsError from './BrickRecommendationsError';
export default BrickRecommendations;
export { BrickRecommendationsError };
